import React from "react";

import { Field } from "react-final-form";

import DateAdapter from "../../Adapters/DateAdapter";

const DateSelectorComponent = ({ name, label, ...props }) => {
  const required = (value) => (value ? undefined : "Required");
  return (
    <Field
      {...props}
      fullWidth
      name={name}
      validate={required}
      label={label}
      component={DateAdapter}
      subscription={{ touched: true, value: true, error: true }}
      inputProps={{ readOnly: true }}
      required
    />
  );
};

export default DateSelectorComponent;
